import { connect } from 'react-redux';
import { advisoryResetCriteria, advisoryStartTool } from 'actions';
import View from './';

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => {
  return {
    advisoryResetCriteria() {
      dispatch(advisoryResetCriteria());
    },
    advisoryStartTool() {
      dispatch(advisoryStartTool());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/advisory-tool/start/container.js